
<template>
  <!-- eslint-disable -->
  <svg :style="style" :class="classes" data-components="CarCheckUnknownSvg" xmlns="http://www.w3.org/2000/svg" fill="none" display="block" overflow="visible" preserveAspectRatio="none" viewBox="0 0 28 28"><path fill="#222" d="M7.583 25.667c0 .644-.522 1.167-1.166 1.167h-3.5a1.167 1.167 0 01-1.167-1.167V24.5h5.833v1.167zm17.5 0c0 .644-.522 1.167-1.166 1.167h-3.5a1.167 1.167 0 01-1.167-1.167V24.5h5.833v1.167zM13.417 5.25c1.934 0 3.65.21 4.933.521.637.155 1.2.342 1.64.558.218.108.434.236.62.392.172.144.392.375.5.706l1.277 3.834h1.55c.953 0 1.73.777 1.73 1.73v.751c0 .784-.362 1.482-.929 1.937.347.532.57 1.07.71 1.615.15.587.198 1.168.212 1.708h.007v.752l-.006 2.92c.003.028.006.057.006.086 0 .03-.003.06-.006.09v.883h-.873a.994.994 0 01-.1.005H3.125v.006H1.167v-4.037c0-.722-.001-1.56.218-2.413.14-.545.364-1.083.71-1.615a2.476 2.476 0 01-.928-1.937v-.75c0-.954.776-1.731 1.73-1.731h1.55l1.277-3.834c.107-.331.327-.562.5-.706.185-.156.402-.284.62-.392.44-.216 1.002-.403 1.64-.558 1.282-.31 2.999-.521 4.933-.521zm-2.194 14.947c-.966 0-1.782.661-2.084 1.584h8.556c-.302-.923-1.119-1.584-2.085-1.584h-4.387zm-7.845-2.73a3.55 3.55 0 00-.098.313c-.14.547-.153 1.107-.155 1.793h4.186a.037.037 0 00.01-.008c.003-.003.004-.007.005-.01l.002-.005c0-.818-.304-1.265-.748-1.557-.51-.334-1.312-.525-2.356-.525h-.846zm20.063-.037a.774.774 0 01-.234.038h-1.235c-.875 0-1.553.176-2.001.484l-.42.418c-.184.277-.296.65-.296 1.18v.006l.007.01.008.006.006.001h4.433c-.002-.686-.016-1.246-.156-1.793a3.526 3.526 0 00-.112-.35zM13.417 7.207c-1.804 0-3.362.198-4.472.467-.559.135-.973.28-1.238.411a1.669 1.669 0 00-.172.096L6.095 12.5l.046.026c.293.154.786.278 1.511.36 1.204.135 2.798.13 4.64.125a408.504 408.504 0 012.248 0c1.843.005 3.438.01 4.642-.125.725-.082 1.218-.206 1.511-.36.016-.008.03-.018.044-.026l-1.44-4.32a1.672 1.672 0 00-.171-.095c-.265-.13-.679-.276-1.237-.411-1.11-.27-2.668-.467-4.472-.467z"/><path fill="#DCD9E6" d="M27.373 7.924a5.591 5.591 0 11-11.182 0 5.591 5.591 0 0111.183 0z"/><path fill="#222" d="M22.688 9.44h-1.544v-.463c0-.375.148-.741.633-1.107l.505-.375c.376-.28.594-.578.594-1.05 0-.481-.327-.79-.871-.79-.594 0-.97.328-.97.915 0 .164.01.318.06.482l-1.526-.126a2.503 2.503 0 01-.069-.558c0-1.117.94-1.868 2.515-1.868 1.564 0 2.485.655 2.485 1.781 0 .703-.376 1.29-.93 1.724l-.456.366c-.317.25-.426.443-.426.79v.278zm.09 2.06h-1.704v-1.473h1.703V11.5z"/></svg>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'CarCheckUnknownSvg',
  mixins: [globalMixin],
  props: {
    width: {
      type: [String, Number, Boolean],
      default: false
    },
    height: {
      type: [String, Number, Boolean],
      default: false
    },
    original: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      const style = {};

      if (this.width) {
        style.width = this.width + 'px';
      }

      if (this.height) {
        style.height = this.height + 'px';
      }

      return style;
    }
  }
};
</script>
